import { render, staticRenderFns } from "./our-story.vue?vue&type=template&id=29b8a6f3&"
import script from "./our-story.vue?vue&type=script&lang=js&"
export * from "./our-story.vue?vue&type=script&lang=js&"
import style0 from "./our-story.vue?vue&type=style&index=0&id=29b8a6f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports